module.exports = __webpack_public_path__ + "static/media/powder_additive.91f882a3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Products/sds/ca/en/powder_additive.pdf
// module id = 323
// module chunks = 0